import { ReactElement } from 'react';
import { Component as EmptyCartIcon } from 'icons/icon-circle--empty-cart.svg';
import { Button } from '../shared/button/Button';
import styles from './EmptyCartDrawer.module.scss';
import CartDrawerHeaderContainer from '../cart-drawer-header/CartDrawerHeaderContainer';
import { Drawer } from '../shared/drawer/Drawer';

type Props = {
    onClick: () => void; // on
    isDrawerOpen: boolean;
    handleClose: () => void;
};

export function EmptyCartDrawer({
  onClick,
  isDrawerOpen,
  handleClose,
}: Props): ReactElement {
  const emptyCartContent = (
    <div className={styles.empty_cart_content__container}>
      <div className={styles.empty_cart_content}>
        <EmptyCartIcon />
        <div className={styles.empty_cart_content__text}>Fill up your cart with plant power!</div>
        <Button className={styles.empty_cart_content__button} onClick={onClick} text="View Menu" />
      </div>
    </div>
  );

  return (
    <>
      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => handleClose()}
        header={<CartDrawerHeaderContainer />}
        content={emptyCartContent}
      />
    </>
  );
}
